export default "__VITE_ASSET__n7VR1lbN__"